module.exports = {
    BaseLayer: require("./baselayer"),
    TiledImageLayer: require("./tiledimagelayer"),
    DataLayer: require("./datalayer"),
    TiledDataOverlay: require("./tileddataoverlay"),
    renderers: require("./renderers"),
};
